import {IRegisterStepperProps} from '../../brand/components/Step1';
import {useDispatch, useSelector} from 'react-redux';
import {IAllStates} from '../../../../store/rootReducer';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {useSearchQuery} from '../../../../shared/hooks/useSearchQuery';
import {ErrorToast, SuccessToast} from '../../../../utils/toasters';
import registrationSlice from '../../../../store/register/brand/registrationSlice';
import {TextField} from '@material-ui/core';
import {Form, Spinner} from 'react-bootstrap';
import {StepperButtons} from '../../brand/components/StepperButtons';
import {AgencyService} from '../service';
import {AuthService} from '../../../service';
import {InternalRoutes} from '../../../../enum/InternalRoutes';
import {IRegistrationStepTwoRequest} from '../../brand/dto/IRegistrationStepTwoRequest';

export const Step2 = ({stepIdNumber, handleBackStep}: IRegisterStepperProps) => {
    const savedData = useSelector((state: IAllStates) => state.registration);
    const {t} = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const token = useSearchQuery('token') as string;
    const utmCampaign = localStorage.getItem('utmCampaign') as string;

    const [confirmationToken, setConfirmationToken] = useState<IRegistrationStepTwoRequest>({
        confirmationToken: '',
        utmCampaign,
    });

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setConfirmationToken(prev => ({...prev, [name]: value}));
    };

    const handleNextStep = () => {
        AgencyService.verifyUserData(token, confirmationToken).then(response => {
            if (response) {
                localStorage.removeItem('utmCampaign');
                history.push(`${InternalRoutes.AGENCY_REGISTRATION}/${stepIdNumber + 1}?token=${response?.verificationUUID}`);
                SuccessToast(t('auth.register.brand.step2.successCode'));
            }
        }).catch(error => ErrorToast(error));
    };

    const resendVerify = () => {
        setIsLoading(true);
        AgencyService.resetVerifyCode(savedData?.email).then(response => {
            SuccessToast(t('auth.register.brand.step1.pleaseCheckEmail'));
        }).catch(error => ErrorToast(error)).finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (!!token?.length) {
            AuthService.getUserDataById('registerAgency', token as string).then(response => {
                dispatch(registrationSlice.actions.setRegisterUser(response));
            }).catch(error => ErrorToast(error));
        }
        // eslint-disable-next-line
    }, [token]);

    useEffect(() => {
        if (savedData?.isEnabled) {
            history.push(`${InternalRoutes.AGENCY_REGISTRATION}/${stepIdNumber + 1}?token=${savedData?.verificationUUID}`);
        }
        // eslint-disable-next-line
    }, [savedData]);

    return (
        <Form className="w-100" onSubmit={(e) => {
            e.preventDefault();
            handleNextStep();
        }}>
            <div className="row justify-content-center">
                <div className="col-md-7">
                    <TextField
                        label="Code"
                        value={confirmationToken?.confirmationToken}
                        onChange={changeHandler}
                        name="confirmationToken"
                        variant="outlined"
                        size="small"
                        required
                        className="w-100 my-2"
                    />
                    <div className="d-flex align-items-center justify-content-between">
                    <span className="text-muted">
                        {t('auth.register.brand.step2.checkSpamFolder')}
                    </span>
                        <a
                           className="d-flex align-items-center justify-content-center"
                           onClick={() => resendVerify()}>
                            {isLoading ? <>
                                Loading... <Spinner animation="border" size="sm" role="status" className="ml-1"/>
                            </> : t('auth.register.brand.step2.reSend')}
                        </a>
                    </div>
                </div>
                <div className="col-12 mt-4">
                    <StepperButtons currentStep={stepIdNumber - 1} handleNextStep={handleNextStep} isBackHidden={true}
                                    handleBackStep={handleBackStep}/>
                </div>
            </div>
        </Form>
    );
};
